module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cw-panneaux-deroulant">    \r\n    <div class="table_ResultatsCompteurs"></div>\r\n    <div class="cwResultats-buttons">\r\n        <!--<button type="button" class="cwBtnConfirmer" value="btnOK">'+
((__t=(i18n.t("common:confirmer")))==null?'':__t)+
'</button>\r\n        <button type="button" class="cwBtnAnnuler" value="btnAnnuler">'+
((__t=(i18n.t("common:cancel")))==null?'':__t)+
'</button>-->\r\n    </div>\r\n\r\n</div>';
}
return __p;
};
